module.exports = __webpack_public_path__ + "img/6.99c97256.png";